import * as React from 'react';
import Statuses from "../../components/bo-core/grids/StatusGrid/Statuses";

class Status extends React.Component {
    render() {
        return (
            <div style={{backgroundColor: '#2B2B2B', height: '100%'}}>
                <Statuses/>
            </div>
        );
    }
}

export default Status



// WEBPACK FOOTER //
// ./app/views/bo-core/Status.tsx